import React, { ChangeEvent, useContext, useState } from "react";
import IDashboardEntryItemUI from "../../../../models/IDashboardEntryItemUI";
import ICatalog_Item from "../../../../models/ICatalog_Item";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import { OwIconButton } from "../../../shared/OwIconButton/OwIconButton";
import { FormattedNumber } from "react-intl";
import SupplierContext from "../../../../contexts/SupplierContext";
import { NumericFormat } from "react-number-format";
import * as _ from "lodash-es";

type Props = {
    item: IDashboardEntryItemUI;
    updateItem: (item: IDashboardEntryItemUI) => void;
    getPricingValue: (item: ICatalog_Item) => number;
};

export const DashboardItemEntryPricePerUnit = (props: Props) => {
    const price = !_.isNil(props.item.manual_price) ? props.item.manual_price : props.getPricingValue(props.item.Catalog_Item);

    const [editMode, setEditMode] = useState<boolean>(false);
    const [pricePerUnit, setPricePerUnit] = useState<number>(price);

    const handlePriceChange = (e: ChangeEvent<any>) => {
        const value = Number(e.target.value);

        if (value) {
            setPricePerUnit(value);
        }
    };

    const updateItem = () => {
        const item: IDashboardEntryItemUI = {
            ...props.item,
        };

        const stdPrice = props.getPricingValue(props.item.Catalog_Item);

        if (pricePerUnit !== stdPrice) {
            item.manual_price = pricePerUnit;
        } else {
            item.manual_price = undefined;
        }

        props.updateItem(item);
        setEditMode(false);
    };

    return (
        <div className={"DashboardItemEntryPricePerUnit"}>
            {editMode ? (
                <div>
                    <OwFnInput fn={handlePriceChange} name={"pricePerUnit"} value={pricePerUnit} />
                    <OwIconButton iconClass={"fas fa-check"} iconColorClass={"text-success"} fn={updateItem} />
                </div>
            ) : (
                <div onClick={() => setEditMode(true)}>
                    <u className={"pointer"}>
                        <NumericFormat
                            value={pricePerUnit}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    </u>
                </div>
            )}
        </div>
    );
};
